import { intlShape } from 'react-intl';
import * as dayjs from 'dayjs';

/**
 * This solution is extracted for SimonSomlai: https://github.com/yahoo/react-intl/issues/416#issuecomment-223039994
 */
// ======================================================
// React intl passes the messages and format functions down the component
// tree using the 'context' scope. the injectIntl HOC basically takes these out
// of the context and injects them into the props of the component. To be able to
// import this translation functionality as a module anywhere (and not just inside react components),
// this function inherits props & context from its parent and exports a singleton that'll
// expose all that shizzle.
// ======================================================
let INTL;
export const initIntlProvider = (context) => {
  INTL = context.intl;
  import(`dayjs/locale/${context.intl.locale}`)
    .then(() => dayjs.locale(context.intl.locale))
    .catch(() => dayjs.locale('en'));
  return INTL;
};

const IntlGlobalProvider = (props, context) => {
  initIntlProvider(context);
  return props.children;
};

IntlGlobalProvider.contextTypes = {
  intl: intlShape.isRequired
};
// ======================================================
// Class that exposes translations
// ======================================================
let instance;
class IntlTranslator {
  // Singleton
  constructor() {
    if (!instance) {
      instance = this;
    }
    return instance;
  }
  // ------------------------------------
  // Formatting Functions
  // ------------------------------------

  // eslint-disable-next-line
  formatMessage(message, values) {
    return INTL.formatMessage(message, values);
  }
}
export const intl = new IntlTranslator();
export const { formatMessage } = intl; // simple bypass.
export default IntlGlobalProvider;
